import React from "react";
import Footer from "../components/Footer";
import Menu from "../components/Menu";
import Navbar from "../components/Navbar";

import About from "./About";
import Contact from "./Contact";
import Hero from "./Hero";
import '../index.css';
import MobileApp from "./MobileApp";
import Service from "./Service";
import ScrollReveal from 'scrollreveal'
const Home = () => {
  function scrollTop(){
    const scrollTop = document.getElementById('scroll-top');
    const scrollHead = document.getElementById('header');
    // When the scroll is higher than 560 viewport height, add the show-scroll class to the a tag with the scroll-top class
    if(this.scrollY >= 560) scrollTop.classList.add('show-scroll'); else scrollTop.classList.remove('show-scroll')
    if(this.scrollY >= 560) scrollHead.classList.add('scroll-header'); else scrollHead.classList.remove('scroll-header')
}
window.addEventListener('scroll', scrollTop)
ScrollReveal({
  origin: 'top',
  distance: '20px',
  duration: 1000,
  reset: true
}).reveal(`.home__data, .home__img,
.about__data, .about__img,
.services__content, .menu__content,
.app__data, .app__img,
.contact__data, .contact__button,
.footer__content`, {
interval: 100
})
  return (
    <>
         <a href="#" className="scrolltop" id="scroll-top">
            <i className='bx bx-chevron-up scrolltop__icon'></i>
        </a>
        <Navbar/>
        <main className="l-main">
        <Hero/>
        <About/>
        <Service/>
        <Menu/>
        <MobileApp/>
        <Contact/>
        </main>
       <Footer/>




     
    </>
  );
};
export default Home;
